const HIPAGES_URL_NONE_WWW = 'homeimprovementpages.com.au';
const HIPAGES_URL_COMPLETE = `www.${HIPAGES_URL_NONE_WWW}`;

const ASSET_URL = `assets.${HIPAGES_URL_NONE_WWW}`;
const ASSET_URL_COMPLETE = `https://${ASSET_URL}`;

const HIPAGES_URL_SHORT = 'hipages.com.au';
const HIPAGES_URL_SHORT_COMPLETE = `www.${HIPAGES_URL_SHORT}`;

const THUMBNAIL_URL = `thumbnail-cloud.${HIPAGES_URL_NONE_WWW}`;
const THUMBNAIL_URL_COMPLETE = `https://${THUMBNAIL_URL}`;

const MEDIACACHE_URL = `mediacache.${HIPAGES_URL_NONE_WWW}`;
const MEDIACACHE_URL_COMPLETE = `https://${MEDIACACHE_URL}`;

const TRADIES_URL = `tradies.${HIPAGES_URL_NONE_WWW}`;
const TRADIES_URL_COMPLETE = `https://${TRADIES_URL}`;

const ON_DEMAND_SERVICE_URL = `on-demand-service.${HIPAGES_URL_NONE_WWW}`;
const ON_DEMAND_SERVICE_URL_COMPLETE = `https://${ON_DEMAND_SERVICE_URL}`;

const ON_DEMAND_JOB_ATTACHMENTS_URL = `on-demand-job-attachments.${HIPAGES_URL_NONE_WWW}`;
const ON_DEMAND_JOB_ATTACHMENTS_URL_COMPLETE = `https://${ON_DEMAND_JOB_ATTACHMENTS_URL}`;

export default {
  ASSET_URL,
  ASSET_URL_COMPLETE,
  ASSET_HUI_IMAGES_URL_BASE: `//${ASSET_URL}/images/hui/`,
  HIPAGES_URL_NONE_WWW,
  HIPAGES_URL_COMPLETE,
  HIPAGES_URL_COMPLETE_WITH_PROTOCOL: `https://${HIPAGES_URL_COMPLETE}`,
  HIPAGES_URL_SHORT,
  HIPAGES_URL_SHORT_COMPLETE,
  HIPAGES_URL_SHORT_COMPLETE_WITH_PROTOCOL: `https://${HIPAGES_URL_SHORT_COMPLETE}`,
  THUMBNAIL_URL,
  THUMBNAIL_URL_COMPLETE,
  MEDIACACHE_URL,
  MEDIACACHE_URL_COMPLETE,
  TRADIES_URL,
  TRADIES_URL_COMPLETE,
  ON_DEMAND_SERVICE_URL,
  ON_DEMAND_SERVICE_URL_COMPLETE,
  ON_DEMAND_JOB_ATTACHMENTS_URL,
  ON_DEMAND_JOB_ATTACHMENTS_URL_COMPLETE
};



// WEBPACK FOOTER //
// ../constants/Domains.js